import React, { useEffect, useState } from "react";
import EntityTableTemplate from "../../MyUI/EntityTableTemplate/EntityTableTemplate";
import { elementsConfig as baseConfig} from "./elements_conf";
import { getElements2 } from "../../../services/services";

export default function Elements() {

  const [elementsConfig, setParamsConfig] = useState(baseConfig);

  const fetchElements = async () => {
    try {
      const res = await getElements2({
        filters: [],
        pagen: 1,
        itemsPerPage: 1000,
        sortBy: '',
        sortDesc: false,
      });
      const combboxElements = res.data.params.map(p => ({
        label: `${p.element_name} ${p.pbscode}`,
        value: p.id
      }));

      // Update formFields dynamically
      const updatedFormFields = baseConfig.formFields.map(f => {
        if (f.key === "parent_id") {
          return { ...f, Autocomplete: combboxElements };
        }
        return f;
      });

      setParamsConfig({ ...baseConfig, formFields: updatedFormFields });
    } catch (err) {
      console.error("Error fetching elements:", err);
    }
  };
  
  useEffect(() => {
    fetchElements();
  }, []); 

  const handleSaved = () => {
    fetchElements();
  };

  if (!elementsConfig) return null;

  return <EntityTableTemplate config={elementsConfig}  onSaved2={handleSaved}/>;
}
